<template>
    <div class="dispatch computilityPage">
        <MyHeader :showText="true" title="协 鑫 智 算 算 力 调 度 平 台" />
        <div class="page-left">
            <Part1 />
            <Part2 />
            <Part3 />
        </div>
        <div class="page-center">
            <!-- <TopTitle class="mt-150"/> -->
            <MyNumber class="disNumber" />
            <MyCenter />
        </div>
        <div class="page-right">
            <Part4 />
            <Part5 />
            <Part6 />
        </div>
    </div>
</template>

<script>
import MyHeader from './../../components/myHeader.vue'
import MyCenter from './center.vue'
import Part1 from './../../components/dispatchCom/part-1.vue'
import Part2 from './../../components/dispatchCom/part-2.vue'
import Part3 from './../../components/dispatchCom/part-3.vue'
import Part4 from './../../components/dispatchCom/part-5.vue'
import Part5 from './../../components/dispatchCom/part-4.vue'
import Part6 from './../../components/dispatchCom/part-6.vue'
import TopTitle from './../../components/TopTitle.vue'
import MyNumber from '../../components/myNumbers.vue'

export default {
    components: {
        MyHeader,
        MyCenter,
        Part1,
        Part2,
        Part3,
        Part4,
        Part5,
        Part6,
        TopTitle,
        MyNumber,
    },
}
</script>

<style lang="scss" scoped>
@import './../../components/comm.scss';

.disNumber{
    position: absolute;
    top: 200px;
}

</style>